
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Frame', component.exports)
}
export default {
	props: {
		ratio: {
			type: String,
			default: '16:9'
		},
		as: {
			type: String,
			default: 'div'
		}
	},
	computed: {
		padding() {
			const [d, n] = this.ratio.split(':');
			if (n && d) {
				return `calc(${n} / ${d} * 100%);`;
			} else {
				return 'calc(9 / 16 * 100%);';
			}
		}
	},
	render: function(createElement) {
		return createElement(
			this.as, // tag name
			{
				class: 'frame',
				style: `--frame-pad: ${this.padding};`
			},
			this.$slots.default // array of children
		);
	}
};
